import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import {
  ActionElementMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/action-element-mixin";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import BackgroundGradient from "%/dynamic-component-editor/options/background-gradient";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";
import normalizeGapValue from "%/dynamic-component-editor/helpers/gap-style-value";
import Padding, {
  PADDING_DEFAULT_EMPTY_VALUE,
} from "%/dynamic-component-editor/options/padding";
import Margins, {
  MARGIN_DEFAULT_EMPTY_VALUE,
} from "%/dynamic-component-editor/options/margins";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";

const SIDES = ["top", "right", "bottom", "left"];

// A compiled surface hands an element that never set its spacing no value at all, so every side is
// filled in here (and the option's own value is never written to).
function fourSides(values, emptyValue) {
  const source = values && typeof values === "object" ? values : {};
  return SIDES.reduce((sides, side) => {
    sides[side] = source[side] ?? emptyValue;
    return sides;
  }, {});
}

export const ActionCountElementMixin = {
  elementPanelSettings: {
    displayIcon: "hyperlink",
    elementType: "element",
  },
  mixins: [ActionElementMixin],
  options: [
    new LayoutGap({
      "default": "extraSmall",
    }),
    new LayoutWidth({
      "default": "hug",
    }, true),
    new LayoutHeight({
      "default": "hug",
    }, true),
  ],
  optionBundles: [
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    ButtonActionCountOptions,
    AnimationEffectsOptions,
    new SpacingOptions({
      "default.padding": {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
    }),
    new BackgroundOptions({}, {
      "background-image": true,
    }),
    BorderOptions,
  ],
  computed: {
    countPending() {
      return false;
    },
    myGap() {
      return normalizeGapValue(this.getOptionValue(LayoutGap));
    },
    myPadding() {
      return fourSides(this.getOptionValue(Padding, BaseOption.$states.DEFAULT, null), PADDING_DEFAULT_EMPTY_VALUE);
    },
    myMargins() {
      return fourSides(this.getOptionValue(Margins, BaseOption.$states.DEFAULT, null), MARGIN_DEFAULT_EMPTY_VALUE);
    },
    myBorderRadius() {
      return this.getOptionValue(BorderRadius);
    },
    containerProps() {
      return {
        gap: this.myGap,
        styleOverrides: {
          paddingTop: this.myPadding.top,
          paddingRight: this.myPadding.right,
          paddingBottom: this.myPadding.bottom,
          paddingLeft: this.myPadding.left,
          marginTop: this.myMargins.top,
          marginRight: this.myMargins.right,
          marginBottom: this.myMargins.bottom,
          marginLeft: this.myMargins.left,
          borderRadius: this.myBorderRadius,
          backgroundColor: this.getOptionValue(BackgroundColor),
          hoverBackgroundColor: this.getOptionValue(BackgroundColor, BaseOption.$states.HOVER),
          backgroundImage: this.getOptionValue(BackgroundGradient),
          backgroundImageHover: this.getOptionValue(BackgroundGradient, BaseOption.$states.HOVER),
        },
        borderTop: this.myBorderSides.top,
        borderBottom: this.myBorderSides.bottom,
        borderLeft: this.myBorderSides.left,
        borderRight: this.myBorderSides.right,
      };
    },
  },
};
